export default __webpack_public_path__ + "static/media/orange_circle.8b69f0d7.svg";